import { Button, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import FundraisingStatusUpdateIcon from "../FundraisingStatusUpdateIcon";

interface Props {
  onClose: () => void;
  onSaveConfirmed: () => void;
}

const ConfirmSaveFundraisingDialog = ({ onClose, onSaveConfirmed }: Props) => {
  return (
    <SmallDialog open onClose={onClose}>
      <DialogTitle>Save Changes</DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent>
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <FundraisingStatusUpdateIcon status="Live" />
          <Stack spacing={1} sx={{ alignItems: "center" }}>
            <Typography noWrap variant="h6">
              Publish changes to Live
            </Typography>
            <Typography color="textSecondary" sx={{ textAlign: "center" }}>
              The content will be published on the portal and will be available to users.
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogButtons onCancel={onClose}>
        <Button variant="contained" onClick={onSaveConfirmed}>
          Save & Publish
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default ConfirmSaveFundraisingDialog;
